import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAccordion, LazyAccordionList, LazyAccordionTestsAccordionListTests, LazyAccordionTests, LazyAnchorLink, LazyBannerCookieBanner, LazyBannerNewsLetterBanner, LazyBannerPopUpBanner, LazyBannerPresentationBanner, LazyBannerPromotionBanner, LazyBannerRegisterBanner, LazyBanner, LazyBannerTypes, LazyBaseSlider, LazyBaseSliderTests, LazyBaseSliderConst, LazyBaseSliderTypes, LazyBigPicture, LazyCta, LazyCtaTests, LazyCtaConst, LazyCtaTypes, LazyChip, LazyChipChipsList, LazyChipTests, LazyChipTestsChipsListTests, LazyChipConst, LazyChipTypes, LazyColumn, LazyCustomLink, LazyDynamicComp, LazyDynamicCompTypes, LazyFooter, LazyFooterTests, LazyFooterConst, LazyFooterTypes, LazyFrames, LazyFramesTests, LazyFramesConst, LazyFramesTypes, LazyGradientsConst, LazyGridLayout, LazyGridTestsGridLayoutTests, LazyGridConst, LazyGridTypes, LazyHeader, LazyHeaderTests, LazyHeaderConst, LazyHeaderTypes, LazyHeadline, LazyHeadlineEventGroup, LazyHeadlineGroup, LazyHeadlineMain, LazyHeadlineTests, LazyHeadlineConst, LazyHeadlineTypes, LazyHighlight, LazyHomePageHero, LazyHubspotForm, LazyHubspotFormConst, LazyIcon, LazyIconConst, LazyIconTypes, LazyIconText, LazyIconTextTypes, LazyIconsAssetRushLabel, LazyIconsAuthLeaf, LazyIconsCopyClipboard, LazyIconsDollar, LazyIconsDoneAll, LazyIconsDownloadIcon, LazyIconsEnvelopeCheckIcon, LazyIconsEtherium, LazyIconsEyeIcon, LazyIconsEyeIconClosed, LazyIconsFacebook, LazyIconsInstagram, LazyIconsLeaf, LazyIconsLeafV1Default, LazyIconsLeafV2Default, LazyIconsLeafV2Large, LazyIconsLeafV3Default, LazyIconsLeafV4Default, LazyIconsLeafV4Large, LazyIconsLeafV5Default, LazyIconsLeafV6Default, LazyIconsLeafV6Large, LazyIconsLeafV6Small, LazyIconsLeafV7Default, LazyIconsLinkedin, LazyIconsLogoIcon, LazyIconsNoContent, LazyIconsNotFoundIllustrator, LazyIconsPlayButton, LazyIconsPresentationIcon, LazyIconsSpinner, LazyIconsTickCircleIcon, LazyIconsTwitter, LazyIconsUpArrow, LazyIconsYoutube, LazyIcons, LazyImage, LazyImageTypes, LazyInput, LazyInputConst, LazyInputTypes, LazyListPostCollections, LazyListPostCollectionsTypes, LazyModalBaseModal, LazyPostCard, LazyPostCardList, LazyPostCardShuffleList, LazyPostCardSlider, LazyPostCardTwoColumnList, LazyPostCardTests, LazyPostCardConst, LazyPostCardTypes, LazyResourcesPage, LazySalemanCta, LazySelect, LazyShareListShareIcon, LazyShareList, LazyShareListTests, LazyShareListConst, LazyShareListTypes, LazySharedReleases, LazyStrapiButton, LazyStrapiButtonList, LazyStrapiButtonTests, LazyStrapiButtonConst, LazyStrapiButtonTypes, LazyStrapiCard, LazyStrapiCardList, LazyStrapiCardTests, LazyStrapiCardConst, LazyStrapiCardTypes, LazyTable, LazyTags, LazyTagsConst, LazyTagsTypes, LazyTestimonials, LazyTestimonialsList, LazyTestimonialsTests, LazyTestimonialsConst, LazyTicker, LazyTickerTests, LazyVideoTestimonialsVideoPost, LazyVideoTestimonials, LazyVideoTestimonialsCustomSlider, LazyVideoTestimonialsSlider, LazyVideoTestimonialsTypes, LazyWraplink, LazyWraplinkList, LazyWraplinkSlider, LazyWraplinkConst, LazyWraplinkTypes } from '#components'
const lazyGlobalComponents = [
  ["Accordion", LazyAccordion],
["AccordionList", LazyAccordionList],
["AccordionTestsAccordionListTests", LazyAccordionTestsAccordionListTests],
["AccordionTests", LazyAccordionTests],
["AnchorLink", LazyAnchorLink],
["BannerCookieBanner", LazyBannerCookieBanner],
["BannerNewsLetterBanner", LazyBannerNewsLetterBanner],
["BannerPopUpBanner", LazyBannerPopUpBanner],
["BannerPresentationBanner", LazyBannerPresentationBanner],
["BannerPromotionBanner", LazyBannerPromotionBanner],
["BannerRegisterBanner", LazyBannerRegisterBanner],
["Banner", LazyBanner],
["BannerTypes", LazyBannerTypes],
["BaseSlider", LazyBaseSlider],
["BaseSliderTests", LazyBaseSliderTests],
["BaseSliderConst", LazyBaseSliderConst],
["BaseSliderTypes", LazyBaseSliderTypes],
["BigPicture", LazyBigPicture],
["Cta", LazyCta],
["CtaTests", LazyCtaTests],
["CtaConst", LazyCtaConst],
["CtaTypes", LazyCtaTypes],
["Chip", LazyChip],
["ChipChipsList", LazyChipChipsList],
["ChipTests", LazyChipTests],
["ChipTestsChipsListTests", LazyChipTestsChipsListTests],
["ChipConst", LazyChipConst],
["ChipTypes", LazyChipTypes],
["Column", LazyColumn],
["CustomLink", LazyCustomLink],
["DynamicComp", LazyDynamicComp],
["DynamicCompTypes", LazyDynamicCompTypes],
["Footer", LazyFooter],
["FooterTests", LazyFooterTests],
["FooterConst", LazyFooterConst],
["FooterTypes", LazyFooterTypes],
["Frames", LazyFrames],
["FramesTests", LazyFramesTests],
["FramesConst", LazyFramesConst],
["FramesTypes", LazyFramesTypes],
["GradientsConst", LazyGradientsConst],
["GridLayout", LazyGridLayout],
["GridTestsGridLayoutTests", LazyGridTestsGridLayoutTests],
["GridConst", LazyGridConst],
["GridTypes", LazyGridTypes],
["Header", LazyHeader],
["HeaderTests", LazyHeaderTests],
["HeaderConst", LazyHeaderConst],
["HeaderTypes", LazyHeaderTypes],
["Headline", LazyHeadline],
["HeadlineEventGroup", LazyHeadlineEventGroup],
["HeadlineGroup", LazyHeadlineGroup],
["HeadlineMain", LazyHeadlineMain],
["HeadlineTests", LazyHeadlineTests],
["HeadlineConst", LazyHeadlineConst],
["HeadlineTypes", LazyHeadlineTypes],
["Highlight", LazyHighlight],
["HomePageHero", LazyHomePageHero],
["HubspotForm", LazyHubspotForm],
["HubspotFormConst", LazyHubspotFormConst],
["Icon", LazyIcon],
["IconConst", LazyIconConst],
["IconTypes", LazyIconTypes],
["IconText", LazyIconText],
["IconTextTypes", LazyIconTextTypes],
["IconsAssetRushLabel", LazyIconsAssetRushLabel],
["IconsAuthLeaf", LazyIconsAuthLeaf],
["IconsCopyClipboard", LazyIconsCopyClipboard],
["IconsDollar", LazyIconsDollar],
["IconsDoneAll", LazyIconsDoneAll],
["IconsDownloadIcon", LazyIconsDownloadIcon],
["IconsEnvelopeCheckIcon", LazyIconsEnvelopeCheckIcon],
["IconsEtherium", LazyIconsEtherium],
["IconsEyeIcon", LazyIconsEyeIcon],
["IconsEyeIconClosed", LazyIconsEyeIconClosed],
["IconsFacebook", LazyIconsFacebook],
["IconsInstagram", LazyIconsInstagram],
["IconsLeaf", LazyIconsLeaf],
["IconsLeafV1Default", LazyIconsLeafV1Default],
["IconsLeafV2Default", LazyIconsLeafV2Default],
["IconsLeafV2Large", LazyIconsLeafV2Large],
["IconsLeafV3Default", LazyIconsLeafV3Default],
["IconsLeafV4Default", LazyIconsLeafV4Default],
["IconsLeafV4Large", LazyIconsLeafV4Large],
["IconsLeafV5Default", LazyIconsLeafV5Default],
["IconsLeafV6Default", LazyIconsLeafV6Default],
["IconsLeafV6Large", LazyIconsLeafV6Large],
["IconsLeafV6Small", LazyIconsLeafV6Small],
["IconsLeafV7Default", LazyIconsLeafV7Default],
["IconsLinkedin", LazyIconsLinkedin],
["IconsLogoIcon", LazyIconsLogoIcon],
["IconsNoContent", LazyIconsNoContent],
["IconsNotFoundIllustrator", LazyIconsNotFoundIllustrator],
["IconsPlayButton", LazyIconsPlayButton],
["IconsPresentationIcon", LazyIconsPresentationIcon],
["IconsSpinner", LazyIconsSpinner],
["IconsTickCircleIcon", LazyIconsTickCircleIcon],
["IconsTwitter", LazyIconsTwitter],
["IconsUpArrow", LazyIconsUpArrow],
["IconsYoutube", LazyIconsYoutube],
["Icons", LazyIcons],
["Image", LazyImage],
["ImageTypes", LazyImageTypes],
["Input", LazyInput],
["InputConst", LazyInputConst],
["InputTypes", LazyInputTypes],
["ListPostCollections", LazyListPostCollections],
["ListPostCollectionsTypes", LazyListPostCollectionsTypes],
["ModalBaseModal", LazyModalBaseModal],
["PostCard", LazyPostCard],
["PostCardList", LazyPostCardList],
["PostCardShuffleList", LazyPostCardShuffleList],
["PostCardSlider", LazyPostCardSlider],
["PostCardTwoColumnList", LazyPostCardTwoColumnList],
["PostCardTests", LazyPostCardTests],
["PostCardConst", LazyPostCardConst],
["PostCardTypes", LazyPostCardTypes],
["ResourcesPage", LazyResourcesPage],
["SalemanCta", LazySalemanCta],
["Select", LazySelect],
["ShareListShareIcon", LazyShareListShareIcon],
["ShareList", LazyShareList],
["ShareListTests", LazyShareListTests],
["ShareListConst", LazyShareListConst],
["ShareListTypes", LazyShareListTypes],
["SharedReleases", LazySharedReleases],
["StrapiButton", LazyStrapiButton],
["StrapiButtonList", LazyStrapiButtonList],
["StrapiButtonTests", LazyStrapiButtonTests],
["StrapiButtonConst", LazyStrapiButtonConst],
["StrapiButtonTypes", LazyStrapiButtonTypes],
["StrapiCard", LazyStrapiCard],
["StrapiCardList", LazyStrapiCardList],
["StrapiCardTests", LazyStrapiCardTests],
["StrapiCardConst", LazyStrapiCardConst],
["StrapiCardTypes", LazyStrapiCardTypes],
["Table", LazyTable],
["Tags", LazyTags],
["TagsConst", LazyTagsConst],
["TagsTypes", LazyTagsTypes],
["Testimonials", LazyTestimonials],
["TestimonialsList", LazyTestimonialsList],
["TestimonialsTests", LazyTestimonialsTests],
["TestimonialsConst", LazyTestimonialsConst],
["Ticker", LazyTicker],
["TickerTests", LazyTickerTests],
["VideoTestimonialsVideoPost", LazyVideoTestimonialsVideoPost],
["VideoTestimonials", LazyVideoTestimonials],
["VideoTestimonialsCustomSlider", LazyVideoTestimonialsCustomSlider],
["VideoTestimonialsSlider", LazyVideoTestimonialsSlider],
["VideoTestimonialsTypes", LazyVideoTestimonialsTypes],
["Wraplink", LazyWraplink],
["WraplinkList", LazyWraplinkList],
["WraplinkSlider", LazyWraplinkSlider],
["WraplinkConst", LazyWraplinkConst],
["WraplinkTypes", LazyWraplinkTypes]
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
